
import { useParams } from 'react-router-dom';
import { SlidersFormState } from '../../../context/sliders/SlidersFormState';
import { Form } from './form';

export const SlidersFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Slider" : "Crear Slider";
  return (
    <SlidersFormState>
        <br />
        <Form title={title} />
    </SlidersFormState>
  );
};
